<div class="container">
    <h1>Privacy Policy</h1>
    <hr />
    <i>19th December, 2023 – Version 3</i>
    <hr />
    <p>
        This privacy policy tells you about the information we collect from you when you use our services, including
        <a href="https://www.mobilecloudsystems.com">https://www.mobilecloudsystems.com</a>,
        <a href="https://work.pimeo.net">https://work.pimeo.net</a>,
        <a href="https://support.pimeo.net">https://support.pimeo.net</a>, or our PIMeo app, collectively referred
        to as "The Platform". We act as both a data controller (for the mobile cloud systems website) and a data
        processor (for the PIMeo websites and applications). By law, we provide information about us, why and how we
        use your data, and your rights over your data.
    </p>

    <h3>Who are we?</h3>
    <p>
        We are Mobile Cloud Systems Ltd. You can contact us by email at <a href="mailto:info@mobilecloudsystems.com">info&#64;mobilecloudsystems.com</a>
        or by telephone on <a href="tel:0035316544801">00353 1 654 4801</a>.
    </p>
    <p>
        We are not required to have a data protection officer, so any enquiries about our use of your personal data should be addressed to the contact details above.
    </p>
    <h3>When you use our website</h3>
    <ul>
        <li>Personal information will only be collected from The Platform, by the following means:</li>
        <li>Through the public website</li>
        <li>Through the online PIMeo platform</li>
        <li>When providing support services in relation to The Platform</li>
        <li>When applying for a job</li>
        <li>When you request a call back, demonstration or consultation</li>
    </ul>
    <p>
        When you use The Platform and view the information we make available, a number of cookies are used by us and by third parties to allow The Platform to function, to collect useful information about visitors and to help to make your user experience better.
        <br />
        Some of the cookies we use are strictly necessary for The Platform to function, and we don’t ask for your consent to place these on your computer. There is no way to prevent these cookies being set other than to not use The Platform.
    </p>
    <p>We do not use cookies to:</p>
    <ul>
        <li>Collect any personally identifiable information (without your express permission)</li>
        <li>Collect any sensitive information (without your express permission)</li>
        <li>Pass personally identifiable data to third parties</li>
        <li>Pay sales commissions</li>
    </ul>
    <p>For more information about our use of cookies, please see our cookie policy.</p>
    <h3>Information Collected</h3>
    <p>
        The Platform collects information to allow users to authenticate and identify themselves. The Platform collects the following information from users to enable them to use our service:
    </p>
    <ul>
        <li>Name</li>
        <li>Email Address</li>
        <li>IP Address</li>
        <li>Company Name</li>
        <li>Phone Numbers</li>
        <li>Job Title</li>
        <li>Project Information</li>
        <li>Log Data</li>
    </ul>
    <p>
        Log Data – We want to inform you that whenever you use The Platform, in a case of an error in The Platform we collect data and information (through third party products) on your device called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilising The Platform, the time and date of your use of The Platform, and other statistics.
    </p>
    <p>
        When you submit an enquiry via The Platform, we may ask you for your name, contact telephone number and email address or alternatively you can just use the email provided to submit your query.
    </p>
    <p>
        We use this information to respond to your query, including providing you with any requested information about our products and services. We may also email you several times after your enquiry in order to follow up on your interest and ensure that we have answered it to your satisfaction. We will do this based on our legitimate interest in providing accurate information prior to a sale.
    </p>
    <p>
        Your enquiry is stored and processed as an email which is hosted by Google within the European Economic Area (EEA) or on servers which are in compliance with European Economic Area (EEA).
    </p>
    <p>
        We do not use the information you provide to make any automated decisions that might affect you.
    </p>
    <p>
        We keep enquiry emails for seven years, after which time we delete them. CRM records are kept for seven years after the last contact with you.
    </p>
    <h3>Service Providers</h3>
    <p>We may employ third-party companies and individuals due to the following reasons:</p>
    <ul>
        <li>To facilitate The Platform</li>
        <li>To provide The Platform on our behalf</li>
        <li>To perform Platform-related services</li>
        <li>To assist us in analyzing how The Platform is used</li>
    </ul>
    <p>
        We want to inform users of this service that these third parties may have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
    </p>
    <h3>Security</h3>
    <p>
        Mobile Cloud Systems Ltd employs a series of systems to safeguard users’ information. These include but are not limited to encrypted communication, encrypted storage of data, firewalls and network monitoring. As a condition of employment all Mobile Cloud Systems Ltd employees are required to treat personal information held on The Platform as confidential.
    </p>
    <p>
        But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
    </p>
    <h3>Links to Other Sites</h3>
    <p>
        The Platform may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
    </p>
    <h3>
        Children’s Privacy
    </h3>
    <p>
        The Platform does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
    </p>
    <h3>
        Your rights as a data subject
    </h3>
    <p>
        You have the right to request access to any of the information we hold about you.  You also have the following rights in relation to the processing of your data:
    </p>
    <ul>
        <li>The right to have your data corrected or rectified</li>
        <li>The right to have us erase/delete your data subject to certain laws that make it compulsory for us to retain certain data</li>
        <li>The right to restrict the processing of your data temporarily</li>
        <li>The right to have your data sent to another company (if you do not already have this data in your possession)</li>
        <li>The right to object to the processing</li>
        <li>The right to know if you are subject to an automated decision and that decision has the effect of profiling</li>
        <li>The right to complain to the Data Protection Commissioner in Ireland</li>
    </ul>
    <p>
        To submit a request regarding your personal data, for example to have your data deleted and removed from our system, please contact <a href="mailto:info@mobilecloudsystems.com">info&#64;mobilecloudsystems.com</a>
    </p>
    <p>Follow a deletion request we do maintain the following items:</p>
    <ul>
        <li>Name</li>
        <li>Email Address</li>
        <li>Company Name</li>
    </ul>
    <p>
        For a minimum of 7 years this is a legitimate purpose as our client may need to access records for legal purposes and these records need to show who and when created same.
    </p>

    <h3>Your right to complain</h3>
    <p>
        If you have a complaint about our use of your information, we would prefer you to contact us directly in the first instance so that we can address your complaint. However, you can also contact the Data Protection Commissioner via their website at <a href="https://www.dataprotection.ie/docs/Contact-us/b/11.htm">https://www.dataprotection.ie/docs/Contact-us/b/11.htm</a> or write to them at:
    </p>
    <address class="contact-address">
        <p>Data Protection Commissioner</p>
        <p>Canal House,</p>
        <p>Station Road,</p>
        <p>Portarlington,</p>
        <p>Co. Laois,</p>
        <p>Ireland</p>
    </address>

    <h3>Updates to this privacy policy</h3>
    <p>
        We regularly review and, if appropriate, update this privacy policy from time to time as our services and use
        of personal data evolve. If we want to make use of your personal data in a way that we haven’t previously
        identified, we will contact you to provide information about this and, if necessary, ask for your consent.
    </p>
    <p>
        We will update the version number and date of this document each time it is changed.
    </p>
</div>
